import React from "react";
import { useQuery } from "@apollo/client";
import { Link, withRouter } from "react-router-dom";
import { Breadcrumb, Header, Loader } from "semantic-ui-react";
import EditFields from "components/EditFields";
import { GET_FIELDS } from "../GraphQL";

const FieldSettings = ({ history }) => {
  const { loading, error, data } = useQuery(GET_FIELDS);

  if (loading) {
    return <Loader active />;
  }
  if (error) {
    throw error;
  }

  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/">Home</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section active>Question Bank</Breadcrumb.Section>
      </Breadcrumb>
      <Header as="h3">
        Question Bank
        <Header.Subheader>
          This is your repository for all questions that could appear on your
          students' reports.{" "}
        </Header.Subheader>
      </Header>
      <EditFields fields={data.myFields} onCancel={() => history.push(`/`)} />
    </div>
  );
};

export default withRouter(FieldSettings);
